// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportReportAction.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var m = require('mobx');
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var ExportFormat = require('logic/data/Izenda.ExportFormatConstants');
  var exportUtils = require('share/utils/Izenda.ExportUtils');
  var subReportLink = require('share/utils/Izenda.SubReportLink');
  var ReportUtils = require('logic/models/Izenda.ReportUtils');
  var systemSettingFetcher = require('fetchers/Izenda.SystemSettingFetcher');
  var exportFetcher = require('fetchers/Izenda.ExportFetcher');
  const ReportPartGridConstants = require('logic/data/Izenda.ReportPartGridConstants');
  const ReportExportIframePopup = require('modules/Reports/ReportViewer/Izenda.ReportExportIframePopup');
  const routeUtils = require('share/utils/Izenda.RouteUtils');
  const { get, getOr, uniqueId, curry, omit, isNil, filter, some, every, map, toUpper, invokeMap, includes } = require('lodash/fp');
  const INTERVAL = 2000;
  var ExportButtonAction = compose(
    withHandlers({
      exportReport: curry(exportReport),
      exportDashboard: curry(exportDashboard),
      getExportFormats: curry(getExportFormats)
    })
  );

  /**
   * function will check that we have to ask or not for state maintain of report/dashboard.
   * @param {*} reportParts
   * @param {*} format
   */
  function showPopUp(reportParts, format) {
    let isCollapsibleItemExist = some(part => {
      const gridStyle = getOr(null, 'reportPartContent.properties.generalInfo.gridStyle', part);
      const separatorList = getOr([], 'reportPartContent.separators.elements', part);
      const isExpandersEnabled = getOr(false, 'reportPartContent.rows.properties.useExpanders', part);
      const isDrilldown = gridStyle === ReportPartGridConstants.GRID_STYLES.DRILL_DOWN.value;
      const isPivot = gridStyle === ReportPartGridConstants.GRID_STYLES.PIVOT.value;

      return isDrilldown || (isPivot && isExpandersEnabled) || separatorList.length > 0;
    }, reportParts || []);

    // show pop up only when user export excel, pdf, word or html (for print)
    switch (format) {
      case ExportFormat.Excel.value:
      case ExportFormat.Pdf.value:
      case ExportFormat.Word.value:
      case ExportFormat.HTML.value:
        break;
      default:
        isCollapsibleItemExist = false;
        break;
    }
    const isReportChanged = isReportTouched(reportParts);
    return isCollapsibleItemExist && isReportChanged
  }

  function showFilterPopup(reportFilters,format)
  {
    let isShowFilterPopup=false;

    if(reportFilters && reportFilters.length>0)
    {
      isShowFilterPopup=true;
    }

    switch (format) {
      case ExportFormat.Pdf.value:
      case ExportFormat.Word.value:
      case ExportFormat.HTML.value:
        break;
      default:
        isShowFilterPopup = false;
        break;
    }

    return isShowFilterPopup;
  }

  /**
   * function will check is there any collapsible record in the report.
   * @param {*} reportParts
   */
  function isReportTouched(reportParts) {
    let isRowsUnChange = isDrillDownRecordUnTouched(reportParts);
    let isSeparatorUnChanged = isSeparatorUnTouched(reportParts)
    return (!isRowsUnChange || !isSeparatorUnChanged)
  }

  /**
   * function will check any row of drill down report is collapsed or not.
   * @param {*} reportParts
   */
  function isDrillDownRecordUnTouched(reportParts) {
    return every(part => {
      const reportInfo = getOr([], 'reportInfo', part);
      return every(d => {
        const isLogicalSeparator = getOr(false, 'separatorInfo.isLogicalSeparator', d);
        if(isLogicalSeparator) {
          const groups = d.records || [];
          return !some(group => !isRowUntouched(group), groups);
        }

        const records = d.records || {};
        return isRowUntouched(records)
      }, reportInfo)
    }, reportParts || []);
  }

  /**
   * function will check row of drill down is collapsed or not.
   * @param {*} record
   */
  function isRowUntouched(record) {
    if (Array.isArray(record)) {
      return true;
    }
    if (!record.isExpand && record.childs.length != 0) {
      return false;
    }
    if (record.childs.length == 0) {
      return true;
    }
    return !some((data) => {
      return !isRowUntouched(data);
    }, record.childs);
  }

  /**
   * function will check any separator is collapsed or not.
   * @param {*} reportParts
   */
  function isSeparatorUnTouched(reportParts) {
    return every(part => {
      const reportInfo = getOr([], 'reportInfo', part);
      return every(d => {
        if (d.separatorInfo) {
          const separatorInfo = d.separatorInfo;
          return separatorInfo.isExpand;
        }
        return true;
      }, reportInfo)
    }, reportParts || [])
  }


  /**
   * Get info of export loading
   */
  function getInfoExportLoading(format, name, key, isReport) {
    const formatType = exportUtils.getFileTypeByFormat(format, isReport);
    let exportName, isPrinting;

    if (format === ExportFormat.HTML.value) {
      exportName = name;
      isPrinting = true;
    } else {
      exportName = `"${name}.${formatType}"`;
    }

    return {
      isPrinting,
      name: exportName,
      key,
      error: false
    };
  }

  /*
   * Call export dashboard by format
   * @param: {object} props   React props
   * @param: {string} format  Export type
   * @param: {event}  event   React event
   */
  function exportDashboard(props, format, event) {
    var name = props.name;
    var exportLoader = props.exportLoader;
    var key = uniqueId(name);
    var id = props.id;

    const isPrint = format === ExportFormat.HTML.value;

    function exportIt() {
      function saveDraft(){
        if(props.isDesignerMode){
          return props.store.saveDraftDataForPrint();
        } 
        return Promise.resolve(id);
      }

      var isExportedFromViewer = props.isDesignerMode;
      var commonFilterFields = isExportedFromViewer
        ? getOr([], 'store.model.dashboardDetail.dashboard.commonFilterFields', props)
        : [];
      commonFilterFields = invokeMap('buildDataForSave', m.toJS(commonFilterFields));
      commonFilterFields = map(filterField => {
        return {
          commonFilterFieldId: filterField.id,
          operatorId: filterField.operatorId,
          operatorSetting: filterField.operatorSetting,
          value: filterField.value,
          defaultValue: filterField.defaultValue
        }
      }, commonFilterFields);

      return saveDraft().then(function (draftIdOrDashboardId) {
        function exportDashboardSync(){
          exportLoader.startExportLoading(getInfoExportLoading(format, name, key, false));
          return props.export(
            draftIdOrDashboardId,
            format,
            exportLoader.endExportLoading.bind(exportLoader, key),
            exportLoader.updateError.bind(exportLoader, key)
          );
        }

        const isMaintainState = get('store.model.dashboardDetail.dashboard.isMaintainState', props);

        if (isPrint || isMaintainState) {
          return exportDashboardSync();
        } else {
          return exportReportOrDashboardAsync(format, draftIdOrDashboardId, commonFilterFields, props, exportDashboardSync.bind(this), isExportedFromViewer, true);
        }
      });
    }

    const dashboardParts = getOr([], 'store.model.dashboardDetail.dashboard.dashboardParts', props);
    const reportParts = map(part => {
      return getOr([], 'reportPart', part)
    }, dashboardParts)
    const isShowPopup = showPopUp(reportParts, format);
    if (isShowPopup) {
      const radioOptions = [{
        label: props.localization.getText('DASHBOARD_CONSTANT_DRILL_DOWN_EXPORT_WITH_PREVIEW_STATE'),
        value: props.localization.getText('COMMON_LABEL_YES')
      },
      {
        label: props.localization.getText('DASHBOARD_CONSTANT_DRILL_DOWN_EXPORT_WITHOUT_PREVIEW_STATE'),
        value: props.localization.getText('COMMON_LABEL_NO')
      }]
      props
        .confirmFn('Confirmation', {
          description: props.localization.getText('DASHBOARD_CONSTANTS_REPORT_DRILL_DOWN_STATE_MAINTAIN'),
          confirmLabel: props.localization.getText('COMMON_LABEL_OK'),
          abortLabel: props.localization.getText('COMMON_LABEL_CANCEL'),
          showRadio: true,
          radioOptions: radioOptions,
          radioValue: props.localization.getText('COMMON_LABEL_YES')
        })
        .then((data) => {
          if(data === props.localization.getText('COMMON_LABEL_YES')) {
            props.store.model.dashboardDetail.dashboard.isMaintainState = true;
          } else {
            props.store.model.dashboardDetail.dashboard.isMaintainState = false;
          }
          exportIt();
        }, (err) => {
        })
    } else {
      exportIt();
    }
  }

  /*
   * Call export report by format
   * @param: {object} props   React props
   * @param: {string} format  Export type
   * @param: {event}  event   React event
   */
  function exportReport(props, format, event) {
    var name = props.name;
    var exportLoader = props.exportLoader;
    var key = uniqueId(name);
    var store = props.store;
    var id = props.id;

    const isPrint = format === ExportFormat.HTML.value;
    const designerStore = props.designerStore;
    const isDesignerStoreDefined = !isNil(designerStore);
    const designerModel = isDesignerStoreDefined ? get('designerStore.model', props) : get('store.model', props);

    function saveDraft() {
      if (props.designerStore) {
        return props.designerStore
          .savePrintDraft()
          .get('id')
          .then(function (draftId) {
            var subReportFilter = get('model.subReportFilter', props.designerStore);
            var subReportFilterFromQuery = getOr({}, 'model.subReportFilterFromQuery', props.designerStore);
            var filters = getOr([], 'filters', subReportFilter);
            var query = subReportLink.convertFilterToQuery(
              omit(['success', 'overideFilterValue'], subReportFilterFromQuery)
            );

            return {
              draftId: draftId,
              subReportFilter: filters,
              queryString: $izenda.param(query || {})
            };
          });
      }

      return Promise.resolve(null);
    }

    function exportFn(exportObj) {
      function exportSyncFunction(){
        var url = window.location.href;
        var actionFn = isPrint
          ? props.print.bind(props.store)
          : props.export.bind(props.store);

        props.isDownloadCompleted && props.isDownloadCompleted(true);
        setTimeout(function() {
          props.isDownloadCompleted && props.isDownloadCompleted(false);
        }, INTERVAL);

        exportLoader.startExportLoading(getInfoExportLoading(format, name, key, true));
        return actionFn(
          url,
          format,
          props.id,
          props.filters,
          exportObj,
          exportLoader.endExportLoading.bind(exportLoader, key),
          exportLoader.updateError.bind(exportLoader, key)
        );
      }

      const isQuickEditMode = isDesignerStoreDefined && designerStore.editMode;
      const isMaintainState = designerModel && designerModel.isMaintainState;

      if(isPrint || isQuickEditMode || isMaintainState) {
        return exportSyncFunction();
      } else {
        var draftId = getOr(null, 'draftId', exportObj);
        var filters = [];
        if(isDesignerStoreDefined) {
          var reportDefenition = designerModel.getReportDefinition();
          var filterFields = getOr([], 'report.reportFilter.filterFields', reportDefenition)
          filters = map(filterField => {
            return {
              filterFieldId: filterField.id,
              operatorId: filterField.operatorId,
              operatorSetting: filterField.operatorSetting,
              value: filterField.value,
              defaultValue: filterField.defaultValue
            }
          }, filterFields);
        }

        return exportReportOrDashboardAsync(format, draftId, filters, props, exportSyncFunction.bind(this), isDesignerStoreDefined);
      }
    }

    function collapsibleItemExistPopup()
    {
      const reportParts = getOr(null, 'reportFields.reportBody.reportParts', designerModel);
      let isShowPopup = showPopUp(reportParts, format);
      if (isShowPopup) {
        const radioOptions = [{
          label: props.localization.getText('REPORT_CONSTANT_DRILL_DOWN_EXPORT_WITH_PREVIEW_STATE'),
          value: props.localization.getText('COMMON_LABEL_YES')
        },
        {
          label: props.localization.getText('REPORT_CONSTANT_DRILL_DOWN_EXPORT_WITHOUT_PREVIEW_STATE'),
          value: props.localization.getText('COMMON_LABEL_NO')
        }]
        props
          .confirmFn('Confirmation', {
            description: props.localization.getText('REPORT_CONSTANTS_DRILL_DOWN_STATE_MAINTAIN'),
            confirmLabel: props.localization.getText('COMMON_LABEL_OK'),
            abortLabel: props.localization.getText('COMMON_LABEL_CANCEL'),
            showRadio: true,
            radioOptions: radioOptions,
            radioValue: props.localization.getText('COMMON_LABEL_YES')
          })
          .then((data) => {
            if (data === props.localization.getText('COMMON_LABEL_YES')) {
              designerModel && (designerModel.isMaintainState = true);
            } else {
              designerModel && (designerModel.isMaintainState = false);
            }
             return saveDraft().then(exportFn);
          }, (err) => {
            // Do nothing as user cancel this the export.
          })
      }
      else {
        designerModel && (designerModel.isMaintainState = false);

        if(format === ExportFormat.Iframe.value){
          const fetcher = require('fetchers/Izenda.UserAccountDataFetcher');
          return fetcher.getAutoAuthToken(props.id).then(result => {
            if(!result.success || !result.data) {
              const message = getOr(props.localization.getText('COMMON_MESSAGES_GENERIC_ERROR'), 'messages[0].messages[0]', result);
              isDesignerStoreDefined && designerStore.alertDetails.set({
                success: false,
                errors: [{ message: message }]
              });
            } else {
              const autoAuthToken = result.data;
              const iframeRoute = routeUtils.getConfigRoute('Report', 'IframeExport');
              const iframeUrl = routeUtils.getRouteUrl(iframeRoute, { id: props.id}) + '?token=' + autoAuthToken;
              const exportUrl = routeUtils.makeAbsoluteUrl(iframeUrl, null, true);
              props.openPopup(ReportExportIframePopup, {
                embedLink: exportUrl
              });
            }
            return Promise.resolve(null);
          });
        }
        return saveDraft().then(exportFn);
      }
    }

    function beginExport() {
      
      const reportFilters = getOr(null, 'reportFields.reportFilter', designerModel);
      
      let isShowFilterPopup=false;
      
      if(!isNil(reportFilters))
      {
        //isShowFilterPopup = showFilterPopup(reportFilters.filterFields,format);
        //reportFilters.isFilterIncludeInExport=false;
        reportFilters.isFilterIncludeInExport=reportFilters.visible;
      }

      if(isShowFilterPopup){
        const radioOptions = [{
          label: props.localization.getText('INCLUDE_FILTER_ON_FIRST_PAGE_IN_EXPORT'),
          value: props.localization.getText('COMMON_LABEL_YES')
        },
        {
          label: props.localization.getText('INCLUDE_FILTER_ON_LAST_PAGE_IN_EXPORT'),
          value: props.localization.getText('COMMON_LABEL_CANCEL')
        }]
        props.confirmFn('Confirmation', {
            description: props.localization.getText('INCLUDE_FILTER_VALUE_IN_EXPORT'),
            confirmLabel: props.localization.getText('COMMON_LABEL_YES'),
            abortLabel: props.localization.getText('COMMON_LABEL_NO'),
            showRadio: true,
            radioOptions: radioOptions,
            radioValue: props.localization.getText('COMMON_LABEL_YES')
          })
          .then((data) => {
            if (data === props.localization.getText('COMMON_LABEL_YES')) {
              reportFilters && (reportFilters.isFilterIncludeFirstinExport = true);
            } else {
              reportFilters && (reportFilters.isFilterIncludeFirstinExport = false);
            }
            reportFilters.isFilterIncludeInExport=true;
          }, (err) => {
            // Do nothing as user cancel this the export.
          })
          .finally((data) => {
            return collapsibleItemExistPopup();
          });
      }
      else
      {
        return collapsibleItemExistPopup();
      }
    }

    function checkFiltersAndExport() {
      if (format === ExportFormat.Query.value || format === ExportFormat.Definition.value) {
        return beginExport();
      }
      var errorMessage = props.localization.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_REQUIRED_FILTER_EXPORT');
      return ReportUtils.checkRequiredFilters(designerStore, props.id).then(function (isValidFilter) {
        if (isValidFilter) {
          return beginExport();
        } else {
          if (isDesignerStoreDefined) {
            designerStore.alertDetails.set({
              success: false,
              errors: [{ message: errorMessage }]
            });
          } else {
            props.confirmMessage('error', errorMessage);
          }
        }
        return false;
      });
    }

    if (store.checkValidReportId) {
      return store.checkValidReportId(id).then(function (result) {
        if (!result.success) {
          var message = result.messages[0] || {};
          var errorMessage = message.messages[0] || '';

          return props.confirmMessage('error', errorMessage);
        } 

        return checkFiltersAndExport();
      });
    }

    return checkFiltersAndExport();
  }

  /**
   * Async Exporting
   */
  function exportReportOrDashboardAsync(format, draftId, filters, props, exportSyncFunction, isExportedFromViewer, isDashboard){
    function saveExportQueue(exportQueue){
      exportQueue.status = 1;
      exportQueue.state = 1;

      return exportFetcher.saveExportQueue(exportQueue).then(result => {
        if(result.success){
          openExportingInProgressPopup();
        }
      });
    }

    function openExportingInProgressPopup(){
      var docType = isDashboard ? 'dashboard' : 'report';
      props.confirmFn('Information', {
        description: String.format(props.localization.getText('REPORT_CONSTANT_ASYNC_EXPORT_IN_PROGRESS'), toUpper(format), props.name, docType),
        showCancel: false
      })
    }

    const syncExportFormats = [
      ExportFormat.Query.value,
      ExportFormat.Definition.value,
      ExportFormat.Iframe.value
    ];

    if(includes(format, syncExportFormats)){
      return exportSyncFunction();
    }

    return systemSettingFetcher.loadExportingConfiguration().then(result => {
      if(!result.isEnableAsyncExporting) {
        return exportSyncFunction();
      } else {
        const tenantId = getOr(null, 'store.tenantId', props);

        const exportFileRefresh = result.asyncRefreshExportingInterval > 0;
        const filtersChanged = some(f => f.value !== f.defaultValue, filters);

        var exportQueue = {
          name: props.name,
          tenantId: tenantId,
          exportFileType: format,
          exportQueueFilterFields: filters,
          reapeat: exportFileRefresh && !filtersChanged ? 1 : 0,
          isExportFromList: !isExportedFromViewer ? 1 : 0
        }

        if(isDashboard) {
          exportQueue.dashboardId = props.id;
        } else {
          exportQueue.reportId = props.id;
        }

        if(draftId) {
          exportQueue.draftId = draftId;
        }

        return exportFetcher.validateExportQueue(exportQueue).then(result => {
          // New
          if(result.status === 1) {
            return saveExportQueue(exportQueue);
          }
          // Ready to download
          else if(result.status === 2) {
            exportQueue.id = result.exportQueueId;
            return exportFetcher.getExportQueueFile(exportQueue);
          }
          // Smart Exporting
          else if(result.status === 3){
            return exportFetcher.validateExportQueueAsync(exportQueue).then(syncExport => {
              if(syncExport) {
                return exportSyncFunction();
              } else {
                return saveExportQueue(exportQueue);
              }
            });
          }
          // Exists
          else if(result.status === 4) {
            openExportingInProgressPopup();
          }
          return null;
        });
      }
    });
  }

  /**
   * Get export format options
   * @param: {object} props   React props
   * @param: {object} event   React event handle
   */
  function getExportFormats(props, event) {
    var authorization = props.authorization;
    var permissionKeys = props.authorizationConstants.PERMISSION_KEY;

    var hasWordPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatWord]);
    var hasExcelPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatExcel]);
    var hasPdfPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatPdf]);
    var hasCsvPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatCsv]);
    var hasXmlPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatXml]);
    var hasJsonPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatJson]);
    var hasQueryPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatQueryExecution]);
    var hasDefinitionPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatDefinition]);
    var hasIframePrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatIframe]);

    if (props.reportDesignerMode) {
      return filter(function (format) {
        return hasQueryPrivilege && format.value === 'query' && format.value !== ExportFormat.HTML.value;
      }, ExportFormat);
    }
    
    return filter(function (format) {
      return (
        format.value !== ExportFormat.HTML.value &&
        (hasWordPrivilege || format.value !== 'word') &&
        (hasExcelPrivilege || format.value !== 'excel') &&
        (hasPdfPrivilege || format.value !== 'pdf') &&
        (hasCsvPrivilege || format.value !== 'csv') &&
        (hasXmlPrivilege || format.value !== 'xml') &&
        (hasJsonPrivilege || format.value !== 'json') &&
        ((hasQueryPrivilege && !props.isDashboard) || format.value !== 'query') &&
        (hasDefinitionPrivilege || format.value !== 'definition') &&
        ((hasIframePrivilege && !props.isDashboard) || format.value !== 'iframe')
      );
    }, ExportFormat);
  }

  module.exports = ExportButtonAction;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ExportButtonAction.jsx